<template>
    <div
        class="long-text-cell"
        @mouseenter="setTooltipTarget($event, data[dataField])">
        {{ data[dataField] }}
    </div>
</template>

<script>
export default {
    name: 'long-text-template',
};
</script>

<script setup>
import { defineProps } from 'vue';

import { setTooltipTarget } from '@/components/utils/ai-gobal-tooltip';

const { dataField, data } = defineProps({
    dataField: {
        type: String,
        default: 'name',
    },
    data: {
        type: Object,
        default: () => {
        },
    },
});
</script>
